import React from 'react';
import { Text, View } from '@smarterservices/smarter-ui';
import { BlockComponentProps, TextBlock as TextBlockType } from '../../types';
import { formatText } from '../../utils/textFormatter';

/**
 * TextBlock component renders a simple text block with optional replacements
 *
 * @param {BlockComponentProps<TextBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered text
 */
export const TextBlock = ({ block }: BlockComponentProps<TextBlockType>) => {
  const formattedText = formatText(block.text, block.replacements);

  return <View 
            as={block?.as as any || 'span'}
            margin={block?.margin || 'none'} 
            textAlign={block?.textAlign || 'start'}
          >
          <Text>{formattedText}</Text>
         </View>;

};

export default TextBlock;
